// @flow
import { SurveysActionTypes } from './constants';

type SurveysAction = { type: string, payload: {} | string };

// common success
export const surveysApiResponseSuccess = (actionType: string, data: any): SurveysAction => ({
    type: SurveysActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const surveysApiResponseError = (actionType: string, error: string): SurveysAction => ({
    type: SurveysActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getSurvey = (id: string): SurveysAction => ({
    type: SurveysActionTypes.GET_SURVEY,
    payload: { id },
});

export const addSurvey = (survey:any):SurveysAction=>({
    type:SurveysActionTypes.ADD_SURVEY,
    payload:survey
})
export const duplicateSurvey = (survey:any):SurveysAction=>({
    type:SurveysActionTypes.DUPLICATE_SURVEY,
    payload:survey
})
export const updateSurvey = (survey:any):SurveysAction=>({
    type:SurveysActionTypes.UPDATE_SURVEY,
    payload:survey
})
export const deleteSurvey = (id:string):SurveysAction=>({
    type:SurveysActionTypes.DELETE_SURVEY,
    payload:{id}
})

export const listSurveys = (params:any): SurveysAction => ({
    type: SurveysActionTypes.LIST_SURVEYS,
    payload: params,
});


export const resetSurveys = (): SurveysAction => ({
    type: SurveysActionTypes.RESET,
    payload: {},
});

